export default "__VITE_ASSET__c7d58462__"